<script setup lang="ts">
/** Aventross AGM (Audited) — 원본 합본 문서 6부((Incorporated In Singapore)). gen_vue 로 템플릿 글자 그대로 생성. */
import CddVarField from '../../../aura/agm/cdd/CddVarField.vue';
import DocScope from '../../../aura/agm/cdd/DocScope.vue';
import AgmSigners from '../../../aura/agm/cdd/AgmSigners.vue';
import { useRepeat } from '../useRepeat';
import '../../../aura/agm/docs/agmDoc.css';
import '../avDoc.css';

const R = useRepeat();
void CddVarField; void DocScope; void AgmSigners;
</script>

<template>
  <div class="agm-doc av-doc">
    <template v-for="id_dir in R.ids('dir')" :key="'dir' + id_dir">
      <DocScope :scope="'dir_' + id_dir + '/'">
        <div class="rep-item"><div class="rep-bar"><span>Director #{{ id_dir }}</span><button type="button" class="rep-rm" title="Remove" @click="R.remove('dir', id_dir)">×</button></div>
          <p class="doc-p center bold"><DocScope scope=""><CddVarField field-key="company_name" label="Company Name" /></DocScope></p>
          <p class="doc-p center">(Incorporated In Singapore)</p>
          <p class="doc-p center">Company Registration No. <DocScope scope=""><CddVarField field-key="company_registration_no" label="Company Registration No." /></DocScope></p>
          <p class="doc-p center">(the “Company”)</p>
          <div class="gap" />
          <p class="doc-p">Name: <CddVarField field-key="director_name" label="Director" /></p>
          <p class="doc-p">Address: <CddVarField field-key="director_address" label="Director address" /></p>
          <p class="doc-p">Date: <DocScope scope=""><CddVarField field-key="agm_date" label="AGM date" /></DocScope></p>
          <div class="gap" />
          <p class="doc-p">Dear Sirs,</p>
          <div class="gap" />
          <p class="doc-p bold">DISCLOSURE OF INTERESTS IN TRANSACTIONS, PROPERTY, OFFICES ETC.</p>
          <p class="doc-p">I hereby give notice, pursuant to Section 156 of the Companies Act, that I am to be regarded as interested in any transaction which may be entered into by the Company with any of the undermentioned corporations or firms after this date.</p>
          <div class="gap" />
          <table class="cdd-tbl av-tbl">
            <tbody>
              <tr><th>Name of Corporation or Firm</th><th>Nature of Interest</th><th>Effective Date</th></tr>
              <template v-for="id_int in R.ids('dir_' + id_dir + '/int')" :key="'int' + id_int">
                <DocScope :scope="'dir_' + id_dir + '/int_' + id_int + '/'">
                  <tr><td><CddVarField field-key="interest_corporation" label="Corporation / firm" /></td><td><CddVarField field-key="interest_nature" label="Nature of interest" /></td><td><CddVarField field-key="interest_effective_date" label="Effective date" /> <button type="button" class="rep-rm" title="Remove row" @click="R.remove('dir_' + id_dir + '/int', id_int)">×</button></td></tr>
                </DocScope>
              </template>
            </tbody>
          </table>
          <button type="button" class="rep-add" @click="R.add('dir_' + id_dir + '/int')">+ Add row</button>
          <div class="gap" />
          <p class="doc-p">Pursuant to Section 156(9) of the Companies Act 1967, I shall be obliged if the Company sent this notice to all the Directors, make ensure that the interests above are brought up and read at the next meeting of the Directors and that the declaration of these interests is recorded in the minutes of that meeting.</p>
          <div class="gap" />
          <p class="doc-p">_______________________</p>
          <p class="doc-p"><CddVarField field-key="director_name" label="Director" /></p>
          <p class="doc-p">Director</p>
          <p class="doc-p">Dated: <CddVarField field-key="disclosure_dated" label="Dated" /> </p>
          <div class="gap" />
        </div>
      </DocScope>
    </template>
    <button type="button" class="rep-add" @click="R.add('dir')">+ Add director</button>
  </div>
</template>
